module.exports = __webpack_public_path__ + "img/qr-code-prod.2b3d8792.png";